export default "__VITE_ASSET__BzGm$jd$__"